import React, { useState } from "react";
import Avatar from "./Avatar";
import logo from "../../assets/images/clientlogo.png";
import whiteLogo from "../../assets/images/whiteTeamslogo.png";
import Transition from "./Transition";
import { Link } from "react-router-dom";
import AgentAvatar from "../AgentAvatar";

const NavBar = ({ avatarurl }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [hidden, setHidden] = useState(false);
  const aName = localStorage.getItem("agentName");

  const handleClick = () => {
    if (isOpen) {
      setIsOpen(false);
      setHidden(false);
    } else {
      setIsOpen(true);
      setHidden(true);
    }
  };

  const optionSelection = (option) => {
    if (option === "request") {
      setIsOpen(false);
      setHidden(false);
    }
  };
  return (
    <nav className="z-30 relative bg-white border-b border-gray-200 dark:bg-white/10 dark:text-white dark:border-gray-600">
      <div className=" mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-16">
          <div className="flex">
            <div className="flex items-center">
              <Link
                to="/dashboard"
                onClick={() => optionSelection("request")}
                className="block px-4 py-2 text-sm leading-5 text-gray-700 hover:bg-gray-100 dark:hover:bg-white/10"
              >
                <img
                  className="h-8 w-auto block dark:hidden"
                  src={logo}
                  alt="Workflow logo"
                />
                <img
                  className="h-8 w-auto hidden dark:block"
                  src={whiteLogo}
                  alt="Workflow logo"
                />
              </Link>
            </div>
          </div>
          <div className="flex">
            <div className="flex-shrink-0 flex items-center text-xl font-semibold tracking-wider">
              {localStorage.getItem("agentName")}
            </div>
          </div>
          <div className="hidden sm:ml-6 sm:flex sm:items-center">
            <div className="flex items-center">
              <button
                onClick={() => {
                  document.documentElement.classList.toggle('dark');
                  localStorage.theme = document.documentElement.classList.contains('dark') ? 'dark' : 'light';
                }}
                className="p-2 rounded-full bg-gray-100 dark:bg-gray-800 text-gray-800 dark:text-white hover:bg-gray-200 dark:hover:bg-gray-700 transition"
                title="Toggle Theme"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="w-5 h-5 hidden dark:block"
                  fill="currentColor"
                  viewBox="0 0 4000 4000"
                >
                  <path d="M2000 1320A680 680 0 102000 2680 680 680 0 102000 1320zM2000 1047.95c-75.105 0-136-60.895-136-136V776c0-75.105 60.895-136 136-136s136 60.895 136 136v135.95C2136 987.056 2075.105 1047.95 2000 1047.95zM2769.383 1366.634c-34.797 0-69.594-13.265-96.156-39.811-53.125-53.092-53.125-139.204-.066-192.329l96.09-96.14c53.125-53.125 139.254-53.142 192.379-.05s53.125 139.204.066 192.329l-96.09 96.14C2839.043 1353.353 2804.18 1366.634 2769.383 1366.634zM3224 2136h-135.934c-75.105 0-136-60.895-136-136s60.895-136 136-136H3224c75.105 0 136 60.895 136 136S3299.105 2136 3224 2136zM2865.473 3001.506c-34.797 0-69.66-13.281-96.223-39.86l-96.09-96.14c-53.059-53.125-53.059-139.237.066-192.329s139.254-53.108 192.379.05l96.09 96.14c53.059 53.125 53.059 139.237-.066 192.329C2935.066 2988.241 2900.27 3001.506 2865.473 3001.506zM2000 3360c-75.105 0-136-60.895-136-136v-135.95c0-75.105 60.895-136 136-136s136 60.895 136 136V3224C2136 3299.105 2075.105 3360 2000 3360zM1134.527 3001.506c-34.797 0-69.594-13.265-96.156-39.811-53.125-53.092-53.125-139.204-.066-192.329l96.09-96.14c53.125-53.158 139.254-53.142 192.379-.05s53.125 139.204.066 192.329l-96.09 96.14C1204.188 2988.208 1169.324 3001.506 1134.527 3001.506zM911.934 2136H776c-75.105 0-136-60.895-136-136s60.895-136 136-136h135.934c75.105 0 136 60.895 136 136S987.039 2136 911.934 2136zM1230.617 1366.634c-34.797 0-69.66-13.281-96.223-39.86l-96.09-96.14c-53.059-53.125-53.059-139.237.066-192.329s139.254-53.108 192.379.05l96.09 96.14c53.059 53.125 53.059 139.237-.066 192.329C1300.211 1353.369 1265.414 1366.634 1230.617 1366.634z" />
                </svg>

                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="w-5 h-5 block dark:hidden"
                  fill="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path d="M21 12.79A9 9 0 0 1 11.21 3a7 7 0 1 0 9.79 9.79z" />
                </svg>
              </button>
            </div>
            <div className="ml-3 relative">
              <div>
                <button
                  className="flex text-sm border-2 border-transparent rounded-full focus:outline-none focus:border-gray-300 transition duration-150 ease-in-out hover:border-gray-300"
                  id="user-menu"
                  aria-label="User menu"
                  aria-haspopup="true"
                  onClick={() => {
                    handleClick();
                  }}
                >
                  <AgentAvatar />
                </button>
              </div>
              <span
                onClick={() => {
                  optionSelection("request");
                }}
                className={
                  (!hidden ? "hidden" : "") +
                  "fixed top-14 left-0 right-0 bottom-0 h-full w-full"
                }
              />
              <Transition
                show={isOpen}
                enter="transition ease-out duration-200 transform"
                enterFrom="opacity-0 scale-50"
                enterTo="opacity-100 scale-100"
                leave="transition ease-in duration-200 transform"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-50"
              >
                <div
                  id="dropDown"
                  className="origin-top-right absolute right-0 mt-2.5 w-36 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 dark:bg-black dark:ring-gray-600"
                  role="menu"
                  aria-orientation="vertical"
                  aria-labelledby="user-menu"
                >
                  {/* <div className="py-2 pl-2 dark:bg-white/10 text-left sm:border-b sm:border-double sm:border-dashed dark:border-gray-500">
                    <div className="text-base font-medium leading-6 text-gray-800 dark:text-white">
                      {aName}
                    </div>
                    <div className="text-sm font-medium leading-5 text-gray-500"></div>
                  </div> */}

                  <div className={""}>
                    <div className="sm:border-t sm:border-dashed sm:border-gray-200 dark:border-gray-900 hover:dark:bg-white/10">
                      <Link
                        to="/dashboard/my-profile"
                        onClick={() => {
                          optionSelection("request");
                        }}
                        className="flex gap-2 pl-2 py-2.5 text-sm dark:text-gray-300 leading-5 text-gray-700 hover:bg-gray-100 hover:dark:text-white dark:bg-white/10 focus:outline-none focus:bg-gray-100 transition duration-150 ease-in-out"
                      >
                        <svg
                          className="w-4 h-4 fill-current text-blue-400 dark:text-white mt-[2.4px]"
                          viewBox="0 0 25 25"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M12 12c2.761 0 5-2.239 5-5S14.761 2 12 2 7 4.239 7 7s2.239 5 5 5zm0 2c-4.418 0-8 2.239-8 5v1h16v-1c0-2.761-3.582-5-8-5z"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="1.6"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          ></path>
                        </svg>
                        My Profile
                      </Link>
                    </div>

                    <div className="sm:border-t sm:border-dashed sm:border-gray-200 dark:border-gray-900 hover:dark:bg-white/10">
                      <Link
                        to="/dashboard/change-password"
                        onClick={() => {
                          optionSelection("request");
                        }}
                        className="flex gap-2 pl-2 py-2.5 text-sm dark:text-gray-300 leading-5 text-gray-700 hover:bg-gray-100 hover:dark:text-white dark:bg-white/10 focus:outline-none focus:bg-gray-100 transition duration-150 ease-in-out"
                      >
                        <svg
                          className="w-4 h-4 fill-current text-blue-400 dark:text-white mt-[2.4px]"
                          viewBox="0 0 32 32"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M25.915,13.739c-0.352-0.802-1.074-1.42-1.934-1.654c-0.307-0.083-0.615-0.145-0.922-0.219 c0.081-0.84,0.112-1.685,0.044-2.523c-0.302-3.687-3.397-6.589-7.039-6.607c-0.007,0-0.111-0.001-0.119,0 c-3.651,0.018-6.747,2.92-7.049,6.607c-0.068,0.836-0.037,1.68,0.044,2.523c-0.307,0.074-0.615,0.136-0.922,0.219 c-0.859,0.234-1.582,0.852-1.935,1.654c-1.822,4.154-1.822,8.367,0.001,12.522c0.352,0.802,1.074,1.42,1.934,1.654 c2.648,0.721,5.314,1.081,7.981,1.081s5.333-0.36,7.981-1.081c0.859-0.234,1.582-0.852,1.935-1.654 C27.738,22.106,27.738,17.894,25.915,13.739z M10.891,9.506c0.218-2.662,2.442-4.757,5.154-4.771 c2.622,0.013,4.847,2.108,5.064,4.77c0.053,0.649,0.035,1.302-0.017,1.954c-3.389-0.585-6.796-0.585-10.185,0 C10.856,10.806,10.838,10.153,10.891,9.506z M17,21.723V23c0,0.552-0.447,1-1,1s-1-0.448-1-1v-1.277c-0.595-0.346-1-0.984-1-1.723 c0-1.105,0.895-2,2-2s2,0.895,2,2C18,20.738,17.595,21.376,17,21.723z"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="1.6"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          ></path>
                        </svg>
                        Change Password
                      </Link>
                    </div>

                    <div className="sm:border-t sm:border-dashed sm:border-gray-200 hover:dark:bg-white/10 dark:border-gray-400">
                      <Link
                        to="/"
                        onClick={() => {
                          optionSelection("request");
                        }}
                        className="flex gap-2 pl-2 py-2.5 text-sm dark:text-gray-300 leading-5 text-gray-700 hover:bg-gray-100 hover:dark:text-white dark:bg-white/10 focus:outline-none focus:bg-gray-100 transition duration-150 ease-in-out"
                      >
                        <svg
                          className="w-4 h-4 fill-current text-blue-500 dark:text-white mt-0.5"
                          viewBox="0 0 50 50"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            fillRule="evenodd"
                            d="M 25 2 C 12.309534 2 2 12.309534 2 25 C 2 37.690466 12.309534 48 25 48 C 32.610275 48 39.366605 44.294736 43.550781 38.591797 A 1.0001 1.0001 0 1 0 41.939453 37.408203 C 38.117629 42.617264 31.961725 46 25 46 C 13.390466 46 4 36.609534 4 25 C 4 13.390466 13.390466 4 25 4 C 31.961725 4 38.117629 7.3827357 41.939453 12.591797 A 1.0001 1.0001 0 1 0 43.550781 11.408203 C 39.366605 5.7052643 32.610275 2 25 2 z M 38.990234 15.990234 A 1.0001 1.0001 0 0 0 38.292969 17.707031 L 44.585938 24 L 23 24 A 1.0001 1.0001 0 1 0 23 26 L 44.585938 26 L 38.292969 32.292969 A 1.0001 1.0001 0 1 0 39.707031 33.707031 L 47.619141 25.794922 A 1.0001 1.0001 0 0 0 47.617188 24.203125 L 39.707031 16.292969 A 1.0001 1.0001 0 0 0 38.990234 15.990234 z"
                          ></path>
                        </svg>
                        Sign out
                      </Link>
                    </div>
                  </div>
                </div>
              </Transition>
            </div>
          </div>
          <div className="-mr-2 flex items-center sm:hidden">
            {/* Mobile menu button */}
            <button
              onClick={() => {
                handleClick();
              }}
              className="inline-flex items-center justify-center p-2 rounded-md text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 focus:text-gray-500 transition duration-150 ease-in-out"
            >
              <svg
                className="block h-6 w-6"
                stroke="currentColor"
                fill="none"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M4 6h16M4 12h16M4 18h16"
                />
              </svg>
              {/* Menu open: "block", Menu closed: "hidden" */}
              <svg
                className="hidden h-6 w-6"
                stroke="currentColor"
                fill="none"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
          </div>
        </div>
      </div>

      <Transition
        show={isOpen}
        enter="transition ease-out duration-100 transform"
        enterFrom="opacity-0 scale-95"
        enterTo="opacity-100 scale-100"
        leave="transition ease-in duration-75 transform"
        leaveFrom="opacity-100 scale-100"
        leaveTo="opacity-0 scale-95"
      >
        <div className="block sm:hidden">
          <div className="pt-4 pb-3 border-t border-gray-200">
            <div className="flex items-center px-4">
              <div className="flex-shrink-0"></div>
              <AgentAvatar />
              <div className="ml-3">
                <div className="text-base font-medium leading-6 text-gray-800">
                  {aName}
                </div>
                <div className="text-sm font-medium leading-5 text-gray-500"></div>
              </div>
            </div>
            <div
              className="mt-3"
              role="menu"
              aria-orientation="vertical"
              aria-labelledby="user-menu"
            >
              <Link
                to="/dashboard/my-profile"
                onClick={() => optionSelection("request")}
                className="block px-4 py-2 text-sm leading-5 text-gray-700 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 transition duration-150 ease-in-out"
              >
                My Profile
              </Link>
              <Link
                to="/"
                onClick={() => {
                  optionSelection("request");
                }}
                className="block px-4 py-2 text-sm leading-5 text-gray-700 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 transition duration-150 ease-in-out"
              >
                Sign out
              </Link>
            </div>
          </div>
        </div>
      </Transition>
    </nav>
  );
};

export default NavBar;
